export { default } from './TranscriptVideo';
export { default as datamap } from './TranscriptVideo.datamap';
export type { PageData } from './TranscriptVideo.datamap';
